import * as Sentry from '@sentry/vue';
import { useUserStore } from '@/stores/user';

export const install = (app, { dsn }) => {
  Sentry.init({
    app,
    dsn,
    beforeSend: event => {
      const userStore = useUserStore();
      // eslint-disable-next-line no-param-reassign
      event.user = {
        ...(event.user || {}),
        email: userStore.user?.email,
        role: userStore.role,
      };
      return event;
    },
  });
};

export default {
  install,
};
